export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.PaymentIndex'
